import * as actionTypes from '../../actions/actionTypes';
import { updateObject } from '../../utility.js';

const initialState = {
    states: [],
    error: false,
    loading: false,
    fetched: false
}

/* ------------------ Countries States Fetch ------------------- */
const helpersCountriesStatesFetchStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false, fetched: false, states: [] } );
};

const helpersCountriesStatesFetchSuccess = ( state, action ) => {
    return updateObject( state, {
        states: action.states,
        loading: false,
        error: false,
        fetched: true
    } );
};

const helpersCountriesStatesFetchFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.HELPERS_COUNTRIES_STATES_FETCH_START: return helpersCountriesStatesFetchStart( state, action );
        case actionTypes.HELPERS_COUNTRIES_STATES_FETCH_SUCCESS: return helpersCountriesStatesFetchSuccess( state, action );
        case actionTypes.HELPERS_COUNTRIES_STATES_FETCH_FAIL: return helpersCountriesStatesFetchFail( state, action );
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/helpers/countriesstates.js